import React, { Fragment } from "react";

import axios from "axios";

import moment from "moment";

import NumberFormat from "react-number-format";

import toast from "react-hot-toast";

import ReactSweetAlert2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Swal: typeof ReactSweetAlert2 = withReactContent(ReactSweetAlert2);

const idLocale = require('moment/locale/id')
moment.updateLocale('id', idLocale);

interface TrxInfoListProps {
	status: number;
	sn: string;
	point: number;
	print: Array<{
		label: string;
		value: string;
	}>;
	counter: number;
	id: string;
	createdAt: string;
	updatedAt: string;
}

const TrxInfoList: React.FC<TrxInfoListProps> = ({
	status,
	sn,
	point,
	print,
	counter,
	id,
	createdAt,
	updatedAt,
}): JSX.Element => {
	return (
		<Fragment>
			{/* TRX INFORMATION */}
			<div className="p-3 bg-white shadow-lg rounded-md lg:rounded-lg">
				{/* PRICE DETAILS */}
				<div className="flex justify-between p-2">
					<div>
						<span className="text-sm lg:text-base font-medium font-dmsans">Informasi Transaksi</span>
					</div>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11.5002 22.75C10.7102 22.75 9.96025 22.34 9.44025 21.64L8.42023 20.3C8.21023 20.02 7.93025 19.86 7.63025 19.84C7.34025 19.82 7.03027 19.96 6.78027 20.21C5.92027 21.13 5.08022 21.57 4.29022 21.55C3.75022 21.53 3.28023 21.29 2.92023 20.85C2.88023 20.8 2.84024 20.73 2.81024 20.66C2.42024 19.82 2.24023 18.68 2.24023 16.97V7.05001C2.24023 5.34001 2.42024 4.21001 2.81024 3.36001C2.84024 3.30001 2.87023 3.24001 2.92023 3.19001C3.27023 2.74001 3.74027 2.50001 4.28027 2.47001C5.08027 2.44001 5.93026 2.90001 6.77026 3.80001C7.02026 4.07001 7.32024 4.20001 7.62024 4.18001C7.92024 4.16001 8.20022 4.00001 8.41022 3.72001L9.43024 2.37001C9.95024 1.67001 10.7002 1.26001 11.4902 1.26001C12.2802 1.26001 13.0302 1.67001 13.5502 2.37001L14.5602 3.71001C14.7702 4.00001 15.0602 4.16001 15.3702 4.18001C15.6602 4.20001 15.9702 4.06001 16.2202 3.80001C17.0402 2.92001 17.8502 2.47001 18.6302 2.47001C19.1902 2.47001 19.7103 2.72001 20.0703 3.19001C20.1103 3.24001 20.1502 3.30001 20.1802 3.37001C20.5702 4.21001 20.7502 5.35001 20.7502 7.06001V16.98C20.7502 18.69 20.5702 19.82 20.1802 20.67C20.1402 20.76 20.0903 20.84 20.0203 20.91C19.7103 21.31 19.2002 21.56 18.6302 21.56C17.8502 21.56 17.0402 21.11 16.2202 20.23C15.9802 19.97 15.6502 19.83 15.3702 19.85C15.0602 19.87 14.7802 20.03 14.5602 20.32L13.5502 21.66C13.0402 22.34 12.2902 22.75 11.5002 22.75ZM7.58026 18.33C7.62026 18.33 7.67027 18.33 7.71027 18.33C8.45027 18.37 9.14023 18.76 9.61023 19.39L10.6302 20.74C11.1202 21.4 11.8602 21.4 12.3502 20.75L13.3602 19.41C13.8402 18.77 14.5403 18.39 15.2803 18.35C16.0203 18.31 16.7602 18.62 17.3002 19.2C18.0402 19.99 18.4902 20.05 18.6102 20.05C18.6902 20.05 18.7603 20.03 18.8303 19.97C19.1103 19.34 19.2302 18.39 19.2302 16.97V7.05001C19.2302 5.65001 19.1003 4.70001 18.8303 4.07001C18.7503 3.98001 18.6702 3.97001 18.6102 3.97001C18.4902 3.97001 18.0402 4.03001 17.3002 4.82001C16.7602 5.40001 16.0203 5.71001 15.2803 5.67001C14.5303 5.63001 13.8302 5.24001 13.3502 4.61001L12.3403 3.27001C11.8503 2.61001 11.1102 2.61001 10.6202 3.27001L9.60022 4.63001C9.13022 5.26001 8.44026 5.64001 7.70026 5.68001C6.96026 5.72001 6.22024 5.41001 5.68024 4.84001C5.07024 4.18001 4.60027 3.96001 4.34027 3.97001C4.28027 3.97001 4.21025 3.99001 4.13025 4.07001C3.86025 4.70001 3.73022 5.65001 3.73022 7.05001V16.97C3.73022 18.38 3.86025 19.33 4.13025 19.96C4.22025 20.04 4.28027 20.05 4.34027 20.06C4.59027 20.07 5.06023 19.85 5.67023 19.2C6.20023 18.63 6.89026 18.33 7.58026 18.33Z" fill="#292D32" />
							<path d="M16 11H8C7.59 11 7.25 10.66 7.25 10.25C7.25 9.84 7.59 9.5 8 9.5H16C16.41 9.5 16.75 9.84 16.75 10.25C16.75 10.66 16.41 11 16 11Z" fill="#292D32" />
							<path d="M14 14.5H8C7.59 14.5 7.25 14.16 7.25 13.75C7.25 13.34 7.59 13 8 13H14C14.41 13 14.75 13.34 14.75 13.75C14.75 14.16 14.41 14.5 14 14.5Z" fill="#292D32" />
						</svg>
					</div>
				</div>
				<hr />

				{/* STATUS PURCHASE */}
				<div className="flex items-start flex-col p-2">
					<div>
						<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Status</span>
					</div>
					<div>
						<span className="text-xs lg:text-sm font-medium font-dmsans">
							{status === 2 ? (
								<span className="text-green-500 uppercase">Sukses</span>
							) : status === 3 ? (
								<span className="text-red-700 uppercase">Gagal</span>
							) : (
								<span className="text-yellow-500 uppercase">Pending</span>
							)}
						</span>
					</div>
				</div>

				{/* COUNTER */}
				<div className="flex items-start flex-col p-2">
					<div>
						<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Pengisian Ke</span>
					</div>
					<div>
						<span className="text-xs lg:text-sm font-medium font-dmsans">{counter ?? 1}</span>
					</div>
				</div>

				{/* BONUS POINT */}
				<div className="flex items-start flex-col p-2">
					<div>
						<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Bonus Poin</span>
					</div>
					<div>
						<span className="text-xs lg:text-sm font-medium font-dmsans">{point} Poin</span>
					</div>
				</div>

				{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
				{print ? (
					<div>
						{/* LABEL NAME */}
						{print.map(({ label, value }, index) => (
							<Fragment key={index}>
								<div className="flex flex-col px-2 py-1 lg:p-2 text-left">
									<div>
										<span className="text-xs lg:text-sm text-gray-500 font-dmsans">{label}</span>
									</div>
									<div style={{ maxWidth: "50%" }}>
										<span className="text-xs lg:text-sm font-medium font-dmsans">{value}</span>
									</div>
								</div>
							</Fragment>
						))}
					</div>
				) : (
					/* WHEN THERE IS A SN SHOW THE LABEL */
					<div className="flex flex-col px-2 py-1 lg:p-2 text-left">
						<div>
							<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Nomor Serial</span>
						</div>
						<div>
							<span className="text-xs lg:text-sm font-medium font-dmsans">{sn ?? "N/A"}</span>
						</div>
					</div>
				)}

				{/* TRX ID */}
				<div className="flex items-start flex-col p-2">
					<div>
						<span className="text-xs lg:text-sm text-gray-500 font-dmsans">ID Transaksi</span>
					</div>
					<div>
						<span className="text-xs lg:text-sm font-medium font-dmsans uppercase">{id}</span>
					</div>
				</div>

				{/* TRX TIME */}
				<div className="flex items-start flex-col p-2">
					<div>
						<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Waktu Transaksi</span>
					</div>
					<div>
						<span className="text-xs lg:text-sm font-medium font-dmsans">{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")} WIB
						</span>
					</div>
				</div>

				{/* STATUS TIME */}
				<div className="flex items-start flex-col p-2">
					<div>
						<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Waktu Status</span>
					</div>
					<div>
						<span className="text-xs lg:text-sm font-medium font-dmsans">{moment.utc(updatedAt).format("DD MMMM YYYY HH:mm:ss")} WIB</span>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

interface ProductDetailsListProps {
	productId?: { nama: string; description: string };
	destination: any;
	sellingPrice: number;
	admin: number;
	paymentBy: string;
}

const ProductDetailsList: React.FC<ProductDetailsListProps> = ({
	productId,
	destination,
	sellingPrice,
	admin,
	paymentBy,
}): JSX.Element => {

	return (
		<div className="p-3 bg-white shadow-lg rounded-md lg:rounded-lg mb-3">
			<div className="flex justify-between p-2">
				<div>
					<span className="text-sm lg:text-base font-medium font-dmsans">{productId?.nama ? productId?.nama : '-'}</span>
				</div>
			</div>
			<hr />

			{/* DESTINATION NUMBER */}
			<div className="flex items-start flex-col p-2">
				<div>
					<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Nomor Tujuan</span>
				</div>
				<div>
					<span className="text-xs lg:text-sm font-medium font-dmsans">{destination}</span>
				</div>
			</div>

			{/* PRODUCT DESCRIPTION */}
			<div className="flex items-start flex-col p-2">
				<div>
					<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Deskripsi Produk</span>
				</div>
				<div>
					<span className="text-xs lg:text-sm font-medium font-dmsans">{productId?.description ? productId?.description : '-'}</span>
				</div>
			</div>

			{/* SELLING PRICE */}
			<div className="flex items-start flex-col p-2">
				<div>
					<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Harga</span>
				</div>
				<div>
					<NumberFormat
						value={sellingPrice}
						className="text-xs lg:text-sm font-medium font-dmsans"
						displayType={"text"}
						thousandSeparator={"."}
						decimalSeparator={","}
						prefix={"Rp "}
					/>
				</div>
			</div>

			{/* ADMIN PRICE */}
			<div className="flex items-start flex-col p-2">
				<div>
					<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Admin</span>
				</div>
				<div>
					<NumberFormat
						value={admin}
						className="text-xs lg:text-sm font-medium font-dmsans"
						displayType={"text"}
						thousandSeparator={"."}
						decimalSeparator={","}
						prefix={"Rp "}
					/>
				</div>
			</div>

			{/* PAYMENT METHOD */}
			<div className="flex items-start flex-col p-2">
				<div>
					<span className="text-xs lg:text-sm text-gray-500 font-dmsans">Metode Pembayaran</span>
				</div>
				<div>
					<span className="text-xs lg:text-sm font-medium font-dmsans uppercase">{paymentBy}</span>
				</div>
			</div>
		</div>
	);
};

function TrxDetails(dataValidate: any): void {
	function getTrxDetails(dataValidate: any): Promise<unknown> {
		return new Promise((resolve, reject): void => {
			axios({
				url: `${process.env.REACT_APP_API_ENDPOINT_URL}/trx/${dataValidate.trx_id ? dataValidate.trx_id : dataValidate.id}/print`,
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: localStorage.getItem("user_token"),
				},
				validateStatus: (status): boolean => true,
			}).then((result: any): void => {
				console.log('[TRX PRINTING]', result)

				if (result.status === 200) {
					resolve(result);
				} else {
					reject(result);
				}

			}).catch((error: any): void => console.log("STATUS CODE", error));
		});
	};

	getTrxDetails(dataValidate).then((result: any): void => {
		const statusCode: number = result.data.status;
		const data: any = result.data.data;

		const {
			admin,
			counter,
			created_at: createdAt,
			harga_jual: sellingPrice,
			payment_by: paymentBy,
			poin: point,
			print,
			produk_id: productId,
			status,
			tujuan: destination,
			sn,
			updated_at: updatedAt,
			_id: id,
		} = data;

		if (statusCode === 200) {
			Swal.fire({
				title: "Detail Transaksi",
				padding: "1rem 0rem",
				confirmButtonText: "Lanjutkan Transaksi Lainnya",
				focusConfirm: true,
				heightAuto: false,
				allowOutsideClick: false,
				customClass: {
					title: "font-inter font-semibold text-lg sm:text-2xl text-gray-800",
					confirmButton: "text-sm lg:text-base font-inter",
				},
				html: (
					<div>
						<ProductDetailsList productId={productId} destination={destination} sellingPrice={sellingPrice} admin={admin} paymentBy={paymentBy} />
						<TrxInfoList status={status} sn={sn ? sn : ''} point={point} print={print} counter={counter} id={id} createdAt={createdAt} updatedAt={updatedAt} />

						<div className="my-4">
							<a
								className="flex justify-center items-center gap-2 text-xs lg:text-sm font-medium text-gray-500 font-dmsans"
								href="/dashboard/customer-service">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M8 22.3199C7.72 22.3199 7.42998 22.2499 7.16998 22.1099C6.59998 21.8099 6.25 21.2099 6.25 20.5699V19.15C3.23 18.84 1.25 16.6199 1.25 13.4399V7.43994C1.25 3.99994 3.56 1.68994 7 1.68994H17C20.44 1.68994 22.75 3.99994 22.75 7.43994V13.4399C22.75 16.8799 20.44 19.1899 17 19.1899H13.23L8.96997 22.03C8.67997 22.22 8.34 22.3199 8 22.3199ZM7 3.17993C4.42 3.17993 2.75 4.84993 2.75 7.42993V13.43C2.75 16.01 4.42 17.68 7 17.68C7.41 17.68 7.75 18.02 7.75 18.43V20.56C7.75 20.69 7.83 20.75 7.88 20.78C7.93 20.81 8.03001 20.84 8.14001 20.77L12.59 17.81C12.71 17.73 12.86 17.68 13.01 17.68H17.01C19.59 17.68 21.26 16.01 21.26 13.43V7.42993C21.26 4.84993 19.59 3.17993 17.01 3.17993H7V3.17993Z" fill="#292D32" />
									<path d="M11.9998 12.1099C11.5898 12.1099 11.2498 11.7699 11.2498 11.3599V11.1499C11.2498 9.9899 12.0998 9.41989 12.4198 9.19989C12.7898 8.94989 12.9098 8.7799 12.9098 8.5199C12.9098 8.0199 12.4998 7.60986 11.9998 7.60986C11.4998 7.60986 11.0898 8.0199 11.0898 8.5199C11.0898 8.9299 10.7498 9.2699 10.3398 9.2699C9.92984 9.2699 9.58984 8.9299 9.58984 8.5199C9.58984 7.1899 10.6698 6.10986 11.9998 6.10986C13.3298 6.10986 14.4098 7.1899 14.4098 8.5199C14.4098 9.6599 13.5698 10.2299 13.2598 10.4399C12.8698 10.6999 12.7498 10.8699 12.7498 11.1499V11.3599C12.7498 11.7799 12.4098 12.1099 11.9998 12.1099Z" fill="#292D32" />
									<path d="M12 14.6001C11.58 14.6001 11.25 14.2601 11.25 13.8501C11.25 13.4401 11.59 13.1001 12 13.1001C12.41 13.1001 12.75 13.4401 12.75 13.8501C12.75 14.2601 12.42 14.6001 12 14.6001Z" fill="#292D32" />
								</svg>
								Komplain ke CS
							</a>
						</div>
					</div>
				),
			});
		}
	}).catch((e: any): void => {
		toast.error(e.data.message, {
			style: {
				fontWeight: "bolder",
			},
		});
		console.log(e);
	});
};

export default TrxDetails;
